module.exports = __webpack_public_path__ + "static/capture-e8d8f5309bb002ccf4df34e02b698ace.gif";